import Promise from '../lib/Promise.js';

class UserActivationTask {
    static run(params) {
        return new UserActivationTask(params).run();
    }

    constructor({env}) {
        this.env = env;
    }

    async onAlreadyActivated() {
        await this.env.getDialog('already-activated-dialog').show();

        this.env.reloadPageWithoutParams();
    }

    onSuccess({institutionName}) {
        this.env.getDialog('activation-success-dialog').setInstitutionName(institutionName).show();
    }

    onUnknownKey() {
        this.env.showDialog('activation-failure-dialog');
    }

    run() {
        if (!this.env.getUrlParams().hasActivateUser()) {
            return Promise.resolve();
        }

        this.env.getProxy().activateUser({key: this.env.getUrlParams().getActivateUser()})
            .then(({institutionName}) => this.onSuccess({institutionName}))
            .catch(error => {
                if (error.hasType('UserAlreadyActivated')) {
                    this.onAlreadyActivated();
                    return;
                }
                else if (error.hasType('UnknownUserActivationKey')) {
                    this.onUnknownKey();
                    return;
                }

                throw error;
            });

        return Promise.inert();
    }
}

export default UserActivationTask;